module.exports = __webpack_public_path__ + "media/images/emblems/Egerkingen-blason-80c6c9507d8a15c2dae56292992cee77.png";